import { render, staticRenderFns } from "./MailToLawyer.vue?vue&type=template&id=707ad03a&scoped=true"
import script from "./MailToLawyer.vue?vue&type=script&lang=js"
export * from "./MailToLawyer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "707ad03a",
  null
  
)

export default component.exports